"use client";
import { useEffect, useState } from "react";
import { Clients } from "@/data/Clients";
import useFramerMotion, {
  m,
  LazyMotion,
  MotionConfig,
  type Variants,
} from "@/hooks/useFramerMotion";

// Animate each row as one unit, then leave it visible. Per-child/repeating
// reveals previously kept the whole list involved in scroll-time style work.
const rowVariants: Variants = {
  opened: {
    y: 0,
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.3,
      ease: "easeOut",
    },
  },
  closed: {
    y: 10,
    opacity: 0,
  },
};

const NotableClients = () => {
  const framerMotionFeatures = useFramerMotion();
  // const items = Clients.sort((a, b) => a.name.localeCompare(b.name));
  const [items, setItems] = useState(Clients);
  useEffect(() => {
    setItems(Clients.sort(() => Math.random() - 0.5));
  }, []);

  return (
    <LazyMotion features={framerMotionFeatures}>
      {/* Reduced-motion: omit vertical movement, retain the brief opacity fade. */}
      <MotionConfig reducedMotion="user">
        <div className="relative z-30 ~/md:~-mx-5/0">
          <ul className="grid grid-cols-1 gap-2 ~text-sm/lg ~gap-y-3/6 md:grid-cols-2 md:gap-x-12">
            {items.map((item, index) => (
              <m.li
                variants={rowVariants}
                initial="closed"
                whileInView={"opened"}
                viewport={{ amount: "some", once: true }}
                key={"client-list-item" + item.id}
                className="underline-links">
                <div className="flex items-baseline justify-between gap-x-3 ~/md:~px-5/0">
                  <div className="flex items-center ~gap-1/3">
                    <div className="font-secondary text-primary/70 ~text-xs/sm">
                      {index + 1}.{" "}
                    </div>

                    <span className="font-medium ~text-sm/xl max-md:truncate">
                      {item.name}
                    </span>
                  </div>
                  <span className="min-w-10 flex-1 border-b-2 border-dotted border-primary/30"></span>
                  <div className="font-secondary text-primary/70 ~text-xs/sm max-md:truncate">
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-mint">
                      {getUrl(item.url)}
                    </a>
                  </div>
                </div>
              </m.li>
            ))}
          </ul>
        </div>
      </MotionConfig>
    </LazyMotion>
  );
};

const getUrl = (url: string) =>
  url.replace(/^https?:\/\/www./, "").replace(/\/$/, "");

NotableClients.displayName = "NotableClients";

export default NotableClients;
